import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import About from "./About";
import LogIn_LogOut from "./LogIn_LogOut";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "./error-page";
import Root from "./routes/root";
import ProtectedRoute from './ProtectedRoute'; 
import Services from './Services'; 
import Contact from './Contact'; 
import Subscription_Management from './Subscription_Management'; 
import { AppContext } from './routes/MyContextProvider';
import Platform_USA_Profile from "./routes/Platform_USA_Profile";
import Platform_USA_Profile_S from "./routes/Platform_USA_Profile_S";
import Core_Token_Type_Definition from "./routes/Core_Token_Type_Definition";
import Core_Token_Type_Definition_S from "./routes/Core_Token_Type_Definition_S";
import Core_Token_Economic_Model_Master from "./routes/Core_Token_Economic_Model_Master";
import Core_Token_Economic_Model_Master_S from "./routes/Core_Token_Economic_Model_Master_S";
import Core_Risk_Color_Matrix from "./routes/Core_Risk_Color_Matrix";
import Core_Risk_Color_Matrix_S from "./routes/Core_Risk_Color_Matrix_S";
import Platform_Module_Config from "./routes/Platform_Module_Config";
import Platform_Module_Config_S from "./routes/Platform_Module_Config_S";
import Workflow_Definition from "./routes/Workflow_Definition";
import Workflow_Definition_S from "./routes/Workflow_Definition_S";
import Workflow_Step_Definition from "./routes/Workflow_Step_Definition";
import Workflow_Step_Definition_S from "./routes/Workflow_Step_Definition_S";
import User_Account from "./routes/User_Account";
import User_Account_S from "./routes/User_Account_S";
import Role_Definition from "./routes/Role_Definition";
import Role_Definition_S from "./routes/Role_Definition_S";
import User_Role_Assignment from "./routes/User_Role_Assignment";
import User_Role_Assignment_S from "./routes/User_Role_Assignment_S";
import System_Code_List from "./routes/System_Code_List";
import System_Code_List_S from "./routes/System_Code_List_S";
import Organization_Profile from "./routes/Organization_Profile";
import Organization_Profile_S from "./routes/Organization_Profile_S";
import Stakeholder_Profile from "./routes/Stakeholder_Profile";
import Stakeholder_Profile_S from "./routes/Stakeholder_Profile_S";
import Investor_Profile from "./routes/Investor_Profile";
import Investor_Profile_S from "./routes/Investor_Profile_S";
import Investor_KYC_AML_Check from "./routes/Investor_KYC_AML_Check";
import Investor_KYC_AML_Check_S from "./routes/Investor_KYC_AML_Check_S";
import Investor_Accreditation_Verification from "./routes/Investor_Accreditation_Verification";
import Investor_Accreditation_Verification_S from "./routes/Investor_Accreditation_Verification_S";
import Investor_Bank_Account from "./routes/Investor_Bank_Account";
import Investor_Bank_Account_S from "./routes/Investor_Bank_Account_S";
import Investor_Risk_Acknowledgment from "./routes/Investor_Risk_Acknowledgment";
import Investor_Risk_Acknowledgment_S from "./routes/Investor_Risk_Acknowledgment_S";
import Core_Data_Room from "./routes/Core_Data_Room";
import Core_Data_Room_S from "./routes/Core_Data_Room_S";
import Core_Data_Room_Document from "./routes/Core_Data_Room_Document";
import Core_Data_Room_Document_S from "./routes/Core_Data_Room_Document_S";
import Core_Document_Verification from "./routes/Core_Document_Verification";
import Core_Document_Verification_S from "./routes/Core_Document_Verification_S";
import Core_Title_Search_Report from "./routes/Core_Title_Search_Report";
import Core_Title_Search_Report_S from "./routes/Core_Title_Search_Report_S";
import Core_Appraisal_Report from "./routes/Core_Appraisal_Report";
import Core_Appraisal_Report_S from "./routes/Core_Appraisal_Report_S";
import Core_Due_Diligence_Checklist from "./routes/Core_Due_Diligence_Checklist";
import Core_Due_Diligence_Checklist_S from "./routes/Core_Due_Diligence_Checklist_S";
import Core_Project_SPV from "./routes/Core_Project_SPV";
import Core_Project_SPV_S from "./routes/Core_Project_SPV_S";
import Core_Legal_Opinion from "./routes/Core_Legal_Opinion";
import Core_Legal_Opinion_S from "./routes/Core_Legal_Opinion_S";
import Core_Escrow_Account from "./routes/Core_Escrow_Account";
import Core_Escrow_Account_S from "./routes/Core_Escrow_Account_S";
import Core_Investor_Protection_Profile from "./routes/Core_Investor_Protection_Profile";
import Core_Investor_Protection_Profile_S from "./routes/Core_Investor_Protection_Profile_S";
import Core_Secondary_Market_Config from "./routes/Core_Secondary_Market_Config";
import Core_Secondary_Market_Config_S from "./routes/Core_Secondary_Market_Config_S";
import Core_Governance_Rule_Set from "./routes/Core_Governance_Rule_Set";
import Core_Governance_Rule_Set_S from "./routes/Core_Governance_Rule_Set_S";
import Workflow_Instance from "./routes/Workflow_Instance";
import Workflow_Instance_S from "./routes/Workflow_Instance_S";
import Core_Audit_Log from "./routes/Core_Audit_Log";
import Core_Audit_Log_S from "./routes/Core_Audit_Log_S";
import Core_Notification from "./routes/Core_Notification";
import Core_Notification_S from "./routes/Core_Notification_S";
import Core_Escrow_Release_Request from "./routes/Core_Escrow_Release_Request";
import Core_Escrow_Release_Request_S from "./routes/Core_Escrow_Release_Request_S";
import Core_Tax_Reporting_Package from "./routes/Core_Tax_Reporting_Package";
import Core_Tax_Reporting_Package_S from "./routes/Core_Tax_Reporting_Package_S";
import Core_Platform_Dashboard from "./routes/Core_Platform_Dashboard";
import Core_Platform_Dashboard_S from "./routes/Core_Platform_Dashboard_S";
import RENT_Asset_Profile from "./routes/RENT_Asset_Profile";
import RENT_Asset_Profile_S from "./routes/RENT_Asset_Profile_S";
import RENT_Property_Management_Agreement from "./routes/RENT_Property_Management_Agreement";
import RENT_Property_Management_Agreement_S from "./routes/RENT_Property_Management_Agreement_S";
import RENT_Unit_Profile from "./routes/RENT_Unit_Profile";
import RENT_Unit_Profile_S from "./routes/RENT_Unit_Profile_S";
import RENT_Token_Offering from "./routes/RENT_Token_Offering";
import RENT_Token_Offering_S from "./routes/RENT_Token_Offering_S";
import RENT_Token_Class from "./routes/RENT_Token_Class";
import RENT_Token_Class_S from "./routes/RENT_Token_Class_S";
import RENT_Token_Economics from "./routes/RENT_Token_Economics";
import RENT_Token_Economics_S from "./routes/RENT_Token_Economics_S";
import RENT_Legal_Rights_Matrix from "./routes/RENT_Legal_Rights_Matrix";
import RENT_Legal_Rights_Matrix_S from "./routes/RENT_Legal_Rights_Matrix_S";
import RENT_Risk_Score from "./routes/RENT_Risk_Score";
import RENT_Risk_Score_S from "./routes/RENT_Risk_Score_S";
import RENT_Subscription_Order from "./routes/RENT_Subscription_Order";
import RENT_Subscription_Order_S from "./routes/RENT_Subscription_Order_S";
import RENT_Token_Ledger from "./routes/RENT_Token_Ledger";
import RENT_Token_Ledger_S from "./routes/RENT_Token_Ledger_S";
import RENT_Independent_Inspection_Report from "./routes/RENT_Independent_Inspection_Report";
import RENT_Independent_Inspection_Report_S from "./routes/RENT_Independent_Inspection_Report_S";
import RENT_Lease_Record from "./routes/RENT_Lease_Record";
import RENT_Lease_Record_S from "./routes/RENT_Lease_Record_S";
import RENT_Rent_Collection_Record from "./routes/RENT_Rent_Collection_Record";
import RENT_Rent_Collection_Record_S from "./routes/RENT_Rent_Collection_Record_S";
import RENT_Property_Manager_Report from "./routes/RENT_Property_Manager_Report";
import RENT_Property_Manager_Report_S from "./routes/RENT_Property_Manager_Report_S";
import RENT_Tenant_Profile from "./routes/RENT_Tenant_Profile";
import RENT_Tenant_Profile_S from "./routes/RENT_Tenant_Profile_S";
import RENT_Rent_Roll_Snapshot from "./routes/RENT_Rent_Roll_Snapshot";
import RENT_Rent_Roll_Snapshot_S from "./routes/RENT_Rent_Roll_Snapshot_S";
import RENT_Operating_Expense_Record from "./routes/RENT_Operating_Expense_Record";
import RENT_Operating_Expense_Record_S from "./routes/RENT_Operating_Expense_Record_S";
import RENT_Reserve_Account_Record from "./routes/RENT_Reserve_Account_Record";
import RENT_Reserve_Account_Record_S from "./routes/RENT_Reserve_Account_Record_S";
import RENT_Delinquency_Vacancy_Record from "./routes/RENT_Delinquency_Vacancy_Record";
import RENT_Delinquency_Vacancy_Record_S from "./routes/RENT_Delinquency_Vacancy_Record_S";
import RENT_Escrow_Release_Package from "./routes/RENT_Escrow_Release_Package";
import RENT_Escrow_Release_Package_S from "./routes/RENT_Escrow_Release_Package_S";
import RENT_Investor_Report from "./routes/RENT_Investor_Report";
import RENT_Investor_Report_S from "./routes/RENT_Investor_Report_S";
import RENT_Distribution_Calculation from "./routes/RENT_Distribution_Calculation";
import RENT_Distribution_Calculation_S from "./routes/RENT_Distribution_Calculation_S";
import RENT_Distribution_Approval from "./routes/RENT_Distribution_Approval";
import RENT_Distribution_Approval_S from "./routes/RENT_Distribution_Approval_S";
import RENT_Lifecycle_Milestone from "./routes/RENT_Lifecycle_Milestone";
import RENT_Lifecycle_Milestone_S from "./routes/RENT_Lifecycle_Milestone_S";
import RENT_Exit_Strategy from "./routes/RENT_Exit_Strategy";
import RENT_Exit_Strategy_S from "./routes/RENT_Exit_Strategy_S";
import REVSHARE_Asset_Profile from "./routes/REVSHARE_Asset_Profile";
import REVSHARE_Asset_Profile_S from "./routes/REVSHARE_Asset_Profile_S";
import REVSHARE_Revenue_Source from "./routes/REVSHARE_Revenue_Source";
import REVSHARE_Revenue_Source_S from "./routes/REVSHARE_Revenue_Source_S";
import REVSHARE_Token_Offering from "./routes/REVSHARE_Token_Offering";
import REVSHARE_Token_Offering_S from "./routes/REVSHARE_Token_Offering_S";
import REVSHARE_Token_Class from "./routes/REVSHARE_Token_Class";
import REVSHARE_Token_Class_S from "./routes/REVSHARE_Token_Class_S";
import REVSHARE_Token_Economics from "./routes/REVSHARE_Token_Economics";
import REVSHARE_Token_Economics_S from "./routes/REVSHARE_Token_Economics_S";
import REVSHARE_Legal_Rights_Matrix from "./routes/REVSHARE_Legal_Rights_Matrix";
import REVSHARE_Legal_Rights_Matrix_S from "./routes/REVSHARE_Legal_Rights_Matrix_S";
import REVSHARE_Risk_Score from "./routes/REVSHARE_Risk_Score";
import REVSHARE_Risk_Score_S from "./routes/REVSHARE_Risk_Score_S";
import REVSHARE_Subscription_Order from "./routes/REVSHARE_Subscription_Order";
import REVSHARE_Subscription_Order_S from "./routes/REVSHARE_Subscription_Order_S";
import REVSHARE_Token_Ledger from "./routes/REVSHARE_Token_Ledger";
import REVSHARE_Token_Ledger_S from "./routes/REVSHARE_Token_Ledger_S";
import REVSHARE_Independent_Inspection_Report from "./routes/REVSHARE_Independent_Inspection_Report";
import REVSHARE_Independent_Inspection_Report_S from "./routes/REVSHARE_Independent_Inspection_Report_S";
import REVSHARE_Revenue_Verification_Report from "./routes/REVSHARE_Revenue_Verification_Report";
import REVSHARE_Revenue_Verification_Report_S from "./routes/REVSHARE_Revenue_Verification_Report_S";
import REVSHARE_Escrow_Release_Package from "./routes/REVSHARE_Escrow_Release_Package";
import REVSHARE_Escrow_Release_Package_S from "./routes/REVSHARE_Escrow_Release_Package_S";
import REVSHARE_Distribution_Calculation from "./routes/REVSHARE_Distribution_Calculation";
import REVSHARE_Distribution_Calculation_S from "./routes/REVSHARE_Distribution_Calculation_S";
import REVSHARE_Investor_Report from "./routes/REVSHARE_Investor_Report";
import REVSHARE_Investor_Report_S from "./routes/REVSHARE_Investor_Report_S";
import REVSHARE_Lifecycle_Milestone from "./routes/REVSHARE_Lifecycle_Milestone";
import REVSHARE_Lifecycle_Milestone_S from "./routes/REVSHARE_Lifecycle_Milestone_S";
import REVSHARE_Exit_Strategy from "./routes/REVSHARE_Exit_Strategy";
import REVSHARE_Exit_Strategy_S from "./routes/REVSHARE_Exit_Strategy_S";
import SALEPROFIT_Asset_Profile from "./routes/SALEPROFIT_Asset_Profile";
import SALEPROFIT_Asset_Profile_S from "./routes/SALEPROFIT_Asset_Profile_S";
import SALEPROFIT_Exit_Strategy from "./routes/SALEPROFIT_Exit_Strategy";
import SALEPROFIT_Exit_Strategy_S from "./routes/SALEPROFIT_Exit_Strategy_S";
import SALEPROFIT_Token_Offering from "./routes/SALEPROFIT_Token_Offering";
import SALEPROFIT_Token_Offering_S from "./routes/SALEPROFIT_Token_Offering_S";
import SALEPROFIT_Token_Class from "./routes/SALEPROFIT_Token_Class";
import SALEPROFIT_Token_Class_S from "./routes/SALEPROFIT_Token_Class_S";
import SALEPROFIT_Token_Economics from "./routes/SALEPROFIT_Token_Economics";
import SALEPROFIT_Token_Economics_S from "./routes/SALEPROFIT_Token_Economics_S";
import SALEPROFIT_Legal_Rights_Matrix from "./routes/SALEPROFIT_Legal_Rights_Matrix";
import SALEPROFIT_Legal_Rights_Matrix_S from "./routes/SALEPROFIT_Legal_Rights_Matrix_S";
import SALEPROFIT_Risk_Score from "./routes/SALEPROFIT_Risk_Score";
import SALEPROFIT_Risk_Score_S from "./routes/SALEPROFIT_Risk_Score_S";
import SALEPROFIT_Independent_Inspection_Report from "./routes/SALEPROFIT_Independent_Inspection_Report";
import SALEPROFIT_Independent_Inspection_Report_S from "./routes/SALEPROFIT_Independent_Inspection_Report_S";
import SALEPROFIT_Subscription_Order from "./routes/SALEPROFIT_Subscription_Order";
import SALEPROFIT_Subscription_Order_S from "./routes/SALEPROFIT_Subscription_Order_S";
import SALEPROFIT_Token_Ledger from "./routes/SALEPROFIT_Token_Ledger";
import SALEPROFIT_Token_Ledger_S from "./routes/SALEPROFIT_Token_Ledger_S";
import SALEPROFIT_Lifecycle_Milestone from "./routes/SALEPROFIT_Lifecycle_Milestone";
import SALEPROFIT_Lifecycle_Milestone_S from "./routes/SALEPROFIT_Lifecycle_Milestone_S";
import SALEPROFIT_Sale_Process from "./routes/SALEPROFIT_Sale_Process";
import SALEPROFIT_Sale_Process_S from "./routes/SALEPROFIT_Sale_Process_S";
import SALEPROFIT_Profit_Waterfall from "./routes/SALEPROFIT_Profit_Waterfall";
import SALEPROFIT_Profit_Waterfall_S from "./routes/SALEPROFIT_Profit_Waterfall_S";
import SALEPROFIT_Distribution_Calculation from "./routes/SALEPROFIT_Distribution_Calculation";
import SALEPROFIT_Distribution_Calculation_S from "./routes/SALEPROFIT_Distribution_Calculation_S";
import SALEPROFIT_Escrow_Release_Package from "./routes/SALEPROFIT_Escrow_Release_Package";
import SALEPROFIT_Escrow_Release_Package_S from "./routes/SALEPROFIT_Escrow_Release_Package_S";
import SALEPROFIT_Investor_Report from "./routes/SALEPROFIT_Investor_Report";
import SALEPROFIT_Investor_Report_S from "./routes/SALEPROFIT_Investor_Report_S";
import EQAPP_Asset_Profile from "./routes/EQAPP_Asset_Profile";
import EQAPP_Asset_Profile_S from "./routes/EQAPP_Asset_Profile_S";
import EQAPP_Token_Offering from "./routes/EQAPP_Token_Offering";
import EQAPP_Token_Offering_S from "./routes/EQAPP_Token_Offering_S";
import EQAPP_Token_Class from "./routes/EQAPP_Token_Class";
import EQAPP_Token_Class_S from "./routes/EQAPP_Token_Class_S";
import EQAPP_Token_Economics from "./routes/EQAPP_Token_Economics";
import EQAPP_Token_Economics_S from "./routes/EQAPP_Token_Economics_S";
import EQAPP_Legal_Rights_Matrix from "./routes/EQAPP_Legal_Rights_Matrix";
import EQAPP_Legal_Rights_Matrix_S from "./routes/EQAPP_Legal_Rights_Matrix_S";
import EQAPP_NAV_Valuation_Report from "./routes/EQAPP_NAV_Valuation_Report";
import EQAPP_NAV_Valuation_Report_S from "./routes/EQAPP_NAV_Valuation_Report_S";
import EQAPP_Appreciation_Calculation from "./routes/EQAPP_Appreciation_Calculation";
import EQAPP_Appreciation_Calculation_S from "./routes/EQAPP_Appreciation_Calculation_S";
import EQAPP_Risk_Score from "./routes/EQAPP_Risk_Score";
import EQAPP_Risk_Score_S from "./routes/EQAPP_Risk_Score_S";
import EQAPP_Independent_Inspection_Report from "./routes/EQAPP_Independent_Inspection_Report";
import EQAPP_Independent_Inspection_Report_S from "./routes/EQAPP_Independent_Inspection_Report_S";
import EQAPP_Subscription_Order from "./routes/EQAPP_Subscription_Order";
import EQAPP_Subscription_Order_S from "./routes/EQAPP_Subscription_Order_S";
import EQAPP_Token_Ledger from "./routes/EQAPP_Token_Ledger";
import EQAPP_Token_Ledger_S from "./routes/EQAPP_Token_Ledger_S";
import EQAPP_Lifecycle_Milestone from "./routes/EQAPP_Lifecycle_Milestone";
import EQAPP_Lifecycle_Milestone_S from "./routes/EQAPP_Lifecycle_Milestone_S";
import EQAPP_Distribution_Calculation from "./routes/EQAPP_Distribution_Calculation";
import EQAPP_Distribution_Calculation_S from "./routes/EQAPP_Distribution_Calculation_S";
import EQAPP_Escrow_Release_Package from "./routes/EQAPP_Escrow_Release_Package";
import EQAPP_Escrow_Release_Package_S from "./routes/EQAPP_Escrow_Release_Package_S";
import EQAPP_Investor_Report from "./routes/EQAPP_Investor_Report";
import EQAPP_Investor_Report_S from "./routes/EQAPP_Investor_Report_S";
import EQAPP_Exit_Strategy from "./routes/EQAPP_Exit_Strategy";
import EQAPP_Exit_Strategy_S from "./routes/EQAPP_Exit_Strategy_S";
import PREFEQ_Asset_Profile from "./routes/PREFEQ_Asset_Profile";
import PREFEQ_Asset_Profile_S from "./routes/PREFEQ_Asset_Profile_S";
import PREFEQ_Token_Offering from "./routes/PREFEQ_Token_Offering";
import PREFEQ_Token_Offering_S from "./routes/PREFEQ_Token_Offering_S";
import PREFEQ_Token_Class from "./routes/PREFEQ_Token_Class";
import PREFEQ_Token_Class_S from "./routes/PREFEQ_Token_Class_S";
import PREFEQ_Token_Economics from "./routes/PREFEQ_Token_Economics";
import PREFEQ_Token_Economics_S from "./routes/PREFEQ_Token_Economics_S";
import PREFEQ_Preferred_Return_Waterfall from "./routes/PREFEQ_Preferred_Return_Waterfall";
import PREFEQ_Preferred_Return_Waterfall_S from "./routes/PREFEQ_Preferred_Return_Waterfall_S";
import PREFEQ_Legal_Rights_Matrix from "./routes/PREFEQ_Legal_Rights_Matrix";
import PREFEQ_Legal_Rights_Matrix_S from "./routes/PREFEQ_Legal_Rights_Matrix_S";
import PREFEQ_Risk_Score from "./routes/PREFEQ_Risk_Score";
import PREFEQ_Risk_Score_S from "./routes/PREFEQ_Risk_Score_S";
import PREFEQ_Subscription_Order from "./routes/PREFEQ_Subscription_Order";
import PREFEQ_Subscription_Order_S from "./routes/PREFEQ_Subscription_Order_S";
import PREFEQ_Token_Ledger from "./routes/PREFEQ_Token_Ledger";
import PREFEQ_Token_Ledger_S from "./routes/PREFEQ_Token_Ledger_S";
import PREFEQ_Capital_Account from "./routes/PREFEQ_Capital_Account";
import PREFEQ_Capital_Account_S from "./routes/PREFEQ_Capital_Account_S";
import PREFEQ_Independent_Inspection_Report from "./routes/PREFEQ_Independent_Inspection_Report";
import PREFEQ_Independent_Inspection_Report_S from "./routes/PREFEQ_Independent_Inspection_Report_S";
import PREFEQ_Escrow_Release_Package from "./routes/PREFEQ_Escrow_Release_Package";
import PREFEQ_Escrow_Release_Package_S from "./routes/PREFEQ_Escrow_Release_Package_S";
import PREFEQ_Distribution_Calculation from "./routes/PREFEQ_Distribution_Calculation";
import PREFEQ_Distribution_Calculation_S from "./routes/PREFEQ_Distribution_Calculation_S";
import PREFEQ_Investor_Report from "./routes/PREFEQ_Investor_Report";
import PREFEQ_Investor_Report_S from "./routes/PREFEQ_Investor_Report_S";
import PREFEQ_Lifecycle_Milestone from "./routes/PREFEQ_Lifecycle_Milestone";
import PREFEQ_Lifecycle_Milestone_S from "./routes/PREFEQ_Lifecycle_Milestone_S";
import PREFEQ_Exit_Strategy from "./routes/PREFEQ_Exit_Strategy";
import PREFEQ_Exit_Strategy_S from "./routes/PREFEQ_Exit_Strategy_S";
import COMEQ_Asset_Profile from "./routes/COMEQ_Asset_Profile";
import COMEQ_Asset_Profile_S from "./routes/COMEQ_Asset_Profile_S";
import COMEQ_Token_Offering from "./routes/COMEQ_Token_Offering";
import COMEQ_Token_Offering_S from "./routes/COMEQ_Token_Offering_S";
import COMEQ_Token_Class from "./routes/COMEQ_Token_Class";
import COMEQ_Token_Class_S from "./routes/COMEQ_Token_Class_S";
import COMEQ_Token_Economics from "./routes/COMEQ_Token_Economics";
import COMEQ_Token_Economics_S from "./routes/COMEQ_Token_Economics_S";
import COMEQ_Legal_Rights_Matrix from "./routes/COMEQ_Legal_Rights_Matrix";
import COMEQ_Legal_Rights_Matrix_S from "./routes/COMEQ_Legal_Rights_Matrix_S";
import COMEQ_Risk_Score from "./routes/COMEQ_Risk_Score";
import COMEQ_Risk_Score_S from "./routes/COMEQ_Risk_Score_S";
import COMEQ_Subscription_Order from "./routes/COMEQ_Subscription_Order";
import COMEQ_Subscription_Order_S from "./routes/COMEQ_Subscription_Order_S";
import COMEQ_Token_Ledger from "./routes/COMEQ_Token_Ledger";
import COMEQ_Token_Ledger_S from "./routes/COMEQ_Token_Ledger_S";
import COMEQ_Cap_Table from "./routes/COMEQ_Cap_Table";
import COMEQ_Cap_Table_S from "./routes/COMEQ_Cap_Table_S";
import COMEQ_Lifecycle_Milestone from "./routes/COMEQ_Lifecycle_Milestone";
import COMEQ_Lifecycle_Milestone_S from "./routes/COMEQ_Lifecycle_Milestone_S";
import COMEQ_Independent_Inspection_Report from "./routes/COMEQ_Independent_Inspection_Report";
import COMEQ_Independent_Inspection_Report_S from "./routes/COMEQ_Independent_Inspection_Report_S";
import COMEQ_Equity_Distribution_Waterfall from "./routes/COMEQ_Equity_Distribution_Waterfall";
import COMEQ_Equity_Distribution_Waterfall_S from "./routes/COMEQ_Equity_Distribution_Waterfall_S";
import COMEQ_Distribution_Calculation from "./routes/COMEQ_Distribution_Calculation";
import COMEQ_Distribution_Calculation_S from "./routes/COMEQ_Distribution_Calculation_S";
import COMEQ_Escrow_Release_Package from "./routes/COMEQ_Escrow_Release_Package";
import COMEQ_Escrow_Release_Package_S from "./routes/COMEQ_Escrow_Release_Package_S";
import COMEQ_Investor_Report from "./routes/COMEQ_Investor_Report";
import COMEQ_Investor_Report_S from "./routes/COMEQ_Investor_Report_S";
import COMEQ_Exit_Strategy from "./routes/COMEQ_Exit_Strategy";
import COMEQ_Exit_Strategy_S from "./routes/COMEQ_Exit_Strategy_S";
import DEBT_Asset_Profile from "./routes/DEBT_Asset_Profile";
import DEBT_Asset_Profile_S from "./routes/DEBT_Asset_Profile_S";
import DEBT_Token_Offering from "./routes/DEBT_Token_Offering";
import DEBT_Token_Offering_S from "./routes/DEBT_Token_Offering_S";
import DEBT_Note_Terms from "./routes/DEBT_Note_Terms";
import DEBT_Note_Terms_S from "./routes/DEBT_Note_Terms_S";
import DEBT_Token_Class from "./routes/DEBT_Token_Class";
import DEBT_Token_Class_S from "./routes/DEBT_Token_Class_S";
import DEBT_Token_Economics from "./routes/DEBT_Token_Economics";
import DEBT_Token_Economics_S from "./routes/DEBT_Token_Economics_S";
import DEBT_Payment_Schedule from "./routes/DEBT_Payment_Schedule";
import DEBT_Payment_Schedule_S from "./routes/DEBT_Payment_Schedule_S";
import DEBT_Legal_Rights_Matrix from "./routes/DEBT_Legal_Rights_Matrix";
import DEBT_Legal_Rights_Matrix_S from "./routes/DEBT_Legal_Rights_Matrix_S";
import DEBT_Risk_Score from "./routes/DEBT_Risk_Score";
import DEBT_Risk_Score_S from "./routes/DEBT_Risk_Score_S";
import DEBT_Independent_Inspection_Report from "./routes/DEBT_Independent_Inspection_Report";
import DEBT_Independent_Inspection_Report_S from "./routes/DEBT_Independent_Inspection_Report_S";
import DEBT_Subscription_Order from "./routes/DEBT_Subscription_Order";
import DEBT_Subscription_Order_S from "./routes/DEBT_Subscription_Order_S";
import DEBT_Token_Ledger from "./routes/DEBT_Token_Ledger";
import DEBT_Token_Ledger_S from "./routes/DEBT_Token_Ledger_S";
import DEBT_Interest_Accrual from "./routes/DEBT_Interest_Accrual";
import DEBT_Interest_Accrual_S from "./routes/DEBT_Interest_Accrual_S";
import DEBT_Distribution_Calculation from "./routes/DEBT_Distribution_Calculation";
import DEBT_Distribution_Calculation_S from "./routes/DEBT_Distribution_Calculation_S";
import DEBT_Escrow_Release_Package from "./routes/DEBT_Escrow_Release_Package";
import DEBT_Escrow_Release_Package_S from "./routes/DEBT_Escrow_Release_Package_S";
import DEBT_Investor_Report from "./routes/DEBT_Investor_Report";
import DEBT_Investor_Report_S from "./routes/DEBT_Investor_Report_S";
import DEBT_Lifecycle_Milestone from "./routes/DEBT_Lifecycle_Milestone";
import DEBT_Lifecycle_Milestone_S from "./routes/DEBT_Lifecycle_Milestone_S";
import DEBT_Exit_Strategy from "./routes/DEBT_Exit_Strategy";
import DEBT_Exit_Strategy_S from "./routes/DEBT_Exit_Strategy_S";
import HYBRID_Asset_Profile from "./routes/HYBRID_Asset_Profile";
import HYBRID_Asset_Profile_S from "./routes/HYBRID_Asset_Profile_S";
import HYBRID_Token_Offering from "./routes/HYBRID_Token_Offering";
import HYBRID_Token_Offering_S from "./routes/HYBRID_Token_Offering_S";
import HYBRID_Component_Mix from "./routes/HYBRID_Component_Mix";
import HYBRID_Component_Mix_S from "./routes/HYBRID_Component_Mix_S";
import HYBRID_Token_Class from "./routes/HYBRID_Token_Class";
import HYBRID_Token_Class_S from "./routes/HYBRID_Token_Class_S";
import HYBRID_Token_Economics from "./routes/HYBRID_Token_Economics";
import HYBRID_Token_Economics_S from "./routes/HYBRID_Token_Economics_S";
import HYBRID_Legal_Rights_Matrix from "./routes/HYBRID_Legal_Rights_Matrix";
import HYBRID_Legal_Rights_Matrix_S from "./routes/HYBRID_Legal_Rights_Matrix_S";
import HYBRID_Risk_Score from "./routes/HYBRID_Risk_Score";
import HYBRID_Risk_Score_S from "./routes/HYBRID_Risk_Score_S";
import HYBRID_Independent_Inspection_Report from "./routes/HYBRID_Independent_Inspection_Report";
import HYBRID_Independent_Inspection_Report_S from "./routes/HYBRID_Independent_Inspection_Report_S";
import HYBRID_Subscription_Order from "./routes/HYBRID_Subscription_Order";
import HYBRID_Subscription_Order_S from "./routes/HYBRID_Subscription_Order_S";
import HYBRID_Token_Ledger from "./routes/HYBRID_Token_Ledger";
import HYBRID_Token_Ledger_S from "./routes/HYBRID_Token_Ledger_S";
import HYBRID_Distribution_Calculation from "./routes/HYBRID_Distribution_Calculation";
import HYBRID_Distribution_Calculation_S from "./routes/HYBRID_Distribution_Calculation_S";
import HYBRID_Combined_Distribution_Waterfall from "./routes/HYBRID_Combined_Distribution_Waterfall";
import HYBRID_Combined_Distribution_Waterfall_S from "./routes/HYBRID_Combined_Distribution_Waterfall_S";
import HYBRID_Escrow_Release_Package from "./routes/HYBRID_Escrow_Release_Package";
import HYBRID_Escrow_Release_Package_S from "./routes/HYBRID_Escrow_Release_Package_S";
import HYBRID_Investor_Report from "./routes/HYBRID_Investor_Report";
import HYBRID_Investor_Report_S from "./routes/HYBRID_Investor_Report_S";
import HYBRID_Lifecycle_Milestone from "./routes/HYBRID_Lifecycle_Milestone";
import HYBRID_Lifecycle_Milestone_S from "./routes/HYBRID_Lifecycle_Milestone_S";
import HYBRID_Exit_Strategy from "./routes/HYBRID_Exit_Strategy";
import HYBRID_Exit_Strategy_S from "./routes/HYBRID_Exit_Strategy_S";
import PREAUCT_Auction_Opportunity from "./routes/PREAUCT_Auction_Opportunity";
import PREAUCT_Auction_Opportunity_S from "./routes/PREAUCT_Auction_Opportunity_S";
import PREAUCT_Auction_Source_Verification from "./routes/PREAUCT_Auction_Source_Verification";
import PREAUCT_Auction_Source_Verification_S from "./routes/PREAUCT_Auction_Source_Verification_S";
import PREAUCT_Pre_Auction_Due_Diligence from "./routes/PREAUCT_Pre_Auction_Due_Diligence";
import PREAUCT_Pre_Auction_Due_Diligence_S from "./routes/PREAUCT_Pre_Auction_Due_Diligence_S";
import PREAUCT_Title_Lien_Precheck from "./routes/PREAUCT_Title_Lien_Precheck";
import PREAUCT_Title_Lien_Precheck_S from "./routes/PREAUCT_Title_Lien_Precheck_S";
import PREAUCT_Auction_Risk_Assessment from "./routes/PREAUCT_Auction_Risk_Assessment";
import PREAUCT_Auction_Risk_Assessment_S from "./routes/PREAUCT_Auction_Risk_Assessment_S";
import PREAUCT_Max_Bid_Analysis from "./routes/PREAUCT_Max_Bid_Analysis";
import PREAUCT_Max_Bid_Analysis_S from "./routes/PREAUCT_Max_Bid_Analysis_S";
import PREAUCT_Pre_Auction_Pool from "./routes/PREAUCT_Pre_Auction_Pool";
import PREAUCT_Pre_Auction_Pool_S from "./routes/PREAUCT_Pre_Auction_Pool_S";
import PREAUCT_Pool_Escrow_Setup from "./routes/PREAUCT_Pool_Escrow_Setup";
import PREAUCT_Pool_Escrow_Setup_S from "./routes/PREAUCT_Pool_Escrow_Setup_S";
import PREAUCT_Compliance_Review from "./routes/PREAUCT_Compliance_Review";
import PREAUCT_Compliance_Review_S from "./routes/PREAUCT_Compliance_Review_S";
import PREAUCT_Investor_Pledge from "./routes/PREAUCT_Investor_Pledge";
import PREAUCT_Investor_Pledge_S from "./routes/PREAUCT_Investor_Pledge_S";
import PREAUCT_Investor_Risk_Acknowledgment from "./routes/PREAUCT_Investor_Risk_Acknowledgment";
import PREAUCT_Investor_Risk_Acknowledgment_S from "./routes/PREAUCT_Investor_Risk_Acknowledgment_S";
import PREAUCT_Bid_Authorization from "./routes/PREAUCT_Bid_Authorization";
import PREAUCT_Bid_Authorization_S from "./routes/PREAUCT_Bid_Authorization_S";
import PREAUCT_Auction_Bid_Submission from "./routes/PREAUCT_Auction_Bid_Submission";
import PREAUCT_Auction_Bid_Submission_S from "./routes/PREAUCT_Auction_Bid_Submission_S";
import PREAUCT_Auction_Result from "./routes/PREAUCT_Auction_Result";
import PREAUCT_Auction_Result_S from "./routes/PREAUCT_Auction_Result_S";
import PREAUCT_Refund_Process from "./routes/PREAUCT_Refund_Process";
import PREAUCT_Refund_Process_S from "./routes/PREAUCT_Refund_Process_S";
import PREAUCT_Winning_Bid_Transition from "./routes/PREAUCT_Winning_Bid_Transition";
import PREAUCT_Winning_Bid_Transition_S from "./routes/PREAUCT_Winning_Bid_Transition_S";
import PREAUCT_Investor_Update_Report from "./routes/PREAUCT_Investor_Update_Report";
import PREAUCT_Investor_Update_Report_S from "./routes/PREAUCT_Investor_Update_Report_S";
import PREAUCT_Final_Pool_Closeout from "./routes/PREAUCT_Final_Pool_Closeout";
import PREAUCT_Final_Pool_Closeout_S from "./routes/PREAUCT_Final_Pool_Closeout_S";
import POSTAUCT_Auction_Result_Intake from "./routes/POSTAUCT_Auction_Result_Intake";
import POSTAUCT_Auction_Result_Intake_S from "./routes/POSTAUCT_Auction_Result_Intake_S";
import POSTAUCT_Acquisition_Closing from "./routes/POSTAUCT_Acquisition_Closing";
import POSTAUCT_Acquisition_Closing_S from "./routes/POSTAUCT_Acquisition_Closing_S";
import POSTAUCT_Post_Auction_Title_Cure from "./routes/POSTAUCT_Post_Auction_Title_Cure";
import POSTAUCT_Post_Auction_Title_Cure_S from "./routes/POSTAUCT_Post_Auction_Title_Cure_S";
import POSTAUCT_Lien_Tax_Clearance from "./routes/POSTAUCT_Lien_Tax_Clearance";
import POSTAUCT_Lien_Tax_Clearance_S from "./routes/POSTAUCT_Lien_Tax_Clearance_S";
import POSTAUCT_Redemption_Period_Review from "./routes/POSTAUCT_Redemption_Period_Review";
import POSTAUCT_Redemption_Period_Review_S from "./routes/POSTAUCT_Redemption_Period_Review_S";
import POSTAUCT_Occupancy_Eviction_Status from "./routes/POSTAUCT_Occupancy_Eviction_Status";
import POSTAUCT_Occupancy_Eviction_Status_S from "./routes/POSTAUCT_Occupancy_Eviction_Status_S";
import POSTAUCT_Property_Condition_Assessment from "./routes/POSTAUCT_Property_Condition_Assessment";
import POSTAUCT_Property_Condition_Assessment_S from "./routes/POSTAUCT_Property_Condition_Assessment_S";
import POSTAUCT_Rehab_Budget from "./routes/POSTAUCT_Rehab_Budget";
import POSTAUCT_Rehab_Budget_S from "./routes/POSTAUCT_Rehab_Budget_S";
import POSTAUCT_Post_Auction_Appraisal from "./routes/POSTAUCT_Post_Auction_Appraisal";
import POSTAUCT_Post_Auction_Appraisal_S from "./routes/POSTAUCT_Post_Auction_Appraisal_S";
import POSTAUCT_SPV_Asset_Transfer from "./routes/POSTAUCT_SPV_Asset_Transfer";
import POSTAUCT_SPV_Asset_Transfer_S from "./routes/POSTAUCT_SPV_Asset_Transfer_S";
import POSTAUCT_Tokenization_Readiness_Checklist from "./routes/POSTAUCT_Tokenization_Readiness_Checklist";
import POSTAUCT_Tokenization_Readiness_Checklist_S from "./routes/POSTAUCT_Tokenization_Readiness_Checklist_S";
import POSTAUCT_Post_Auction_Risk_Score from "./routes/POSTAUCT_Post_Auction_Risk_Score";
import POSTAUCT_Post_Auction_Risk_Score_S from "./routes/POSTAUCT_Post_Auction_Risk_Score_S";
import POSTAUCT_Offering_Readiness from "./routes/POSTAUCT_Offering_Readiness";
import POSTAUCT_Offering_Readiness_S from "./routes/POSTAUCT_Offering_Readiness_S";
import POSTAUCT_Investor_Disclosure_Package from "./routes/POSTAUCT_Investor_Disclosure_Package";
import POSTAUCT_Investor_Disclosure_Package_S from "./routes/POSTAUCT_Investor_Disclosure_Package_S";
import POSTAUCT_Final_Tokenization_Approval from "./routes/POSTAUCT_Final_Tokenization_Approval";
import POSTAUCT_Final_Tokenization_Approval_S from "./routes/POSTAUCT_Final_Tokenization_Approval_S";
import POSTAUCT_Investor_Update_Report from "./routes/POSTAUCT_Investor_Update_Report";
import POSTAUCT_Investor_Update_Report_S from "./routes/POSTAUCT_Investor_Update_Report_S";



const router = createBrowserRouter([
  {
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <App />,
      }
	  ,{
        path: "about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />, 
      },
      {
        path: "/services",
        element: <Services />, 
      },
      {
        path: "/contact",
        element: <Contact />, 
      },
      {
        path: "/Subscription",
        element: <Subscription_Management />, 
      },
      {
        path: "login_logout",
        element: <LogIn_LogOut />,
      }
	  ,{
        path: "Platform_USA_Profile",
        element:  <ProtectedRoute>  <Platform_USA_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "Platform_USA_Profile_S",
        element:  <ProtectedRoute>  <Platform_USA_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Token_Type_Definition",
        element:  <ProtectedRoute>  <Core_Token_Type_Definition />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Token_Type_Definition_S",
        element:  <ProtectedRoute>  <Core_Token_Type_Definition_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Token_Economic_Model_Master",
        element:  <ProtectedRoute>  <Core_Token_Economic_Model_Master />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Token_Economic_Model_Master_S",
        element:  <ProtectedRoute>  <Core_Token_Economic_Model_Master_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Risk_Color_Matrix",
        element:  <ProtectedRoute>  <Core_Risk_Color_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Risk_Color_Matrix_S",
        element:  <ProtectedRoute>  <Core_Risk_Color_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Platform_Module_Config",
        element:  <ProtectedRoute>  <Platform_Module_Config />  </ProtectedRoute>,
      }
	  ,{
        path: "Platform_Module_Config_S",
        element:  <ProtectedRoute>  <Platform_Module_Config_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Definition",
        element:  <ProtectedRoute>  <Workflow_Definition />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Definition_S",
        element:  <ProtectedRoute>  <Workflow_Definition_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Step_Definition",
        element:  <ProtectedRoute>  <Workflow_Step_Definition />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Step_Definition_S",
        element:  <ProtectedRoute>  <Workflow_Step_Definition_S />  </ProtectedRoute>,
      }
	  ,{
        path: "User_Account",
        element:  <ProtectedRoute>  <User_Account />  </ProtectedRoute>,
      }
	  ,{
        path: "User_Account_S",
        element:  <ProtectedRoute>  <User_Account_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Role_Definition",
        element:  <ProtectedRoute>  <Role_Definition />  </ProtectedRoute>,
      }
	  ,{
        path: "Role_Definition_S",
        element:  <ProtectedRoute>  <Role_Definition_S />  </ProtectedRoute>,
      }
	  ,{
        path: "User_Role_Assignment",
        element:  <ProtectedRoute>  <User_Role_Assignment />  </ProtectedRoute>,
      }
	  ,{
        path: "User_Role_Assignment_S",
        element:  <ProtectedRoute>  <User_Role_Assignment_S />  </ProtectedRoute>,
      }
	  ,{
        path: "System_Code_List",
        element:  <ProtectedRoute>  <System_Code_List />  </ProtectedRoute>,
      }
	  ,{
        path: "System_Code_List_S",
        element:  <ProtectedRoute>  <System_Code_List_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Organization_Profile",
        element:  <ProtectedRoute>  <Organization_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "Organization_Profile_S",
        element:  <ProtectedRoute>  <Organization_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Stakeholder_Profile",
        element:  <ProtectedRoute>  <Stakeholder_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "Stakeholder_Profile_S",
        element:  <ProtectedRoute>  <Stakeholder_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Profile",
        element:  <ProtectedRoute>  <Investor_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Profile_S",
        element:  <ProtectedRoute>  <Investor_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_KYC_AML_Check",
        element:  <ProtectedRoute>  <Investor_KYC_AML_Check />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_KYC_AML_Check_S",
        element:  <ProtectedRoute>  <Investor_KYC_AML_Check_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Accreditation_Verification",
        element:  <ProtectedRoute>  <Investor_Accreditation_Verification />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Accreditation_Verification_S",
        element:  <ProtectedRoute>  <Investor_Accreditation_Verification_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Bank_Account",
        element:  <ProtectedRoute>  <Investor_Bank_Account />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Bank_Account_S",
        element:  <ProtectedRoute>  <Investor_Bank_Account_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Risk_Acknowledgment",
        element:  <ProtectedRoute>  <Investor_Risk_Acknowledgment />  </ProtectedRoute>,
      }
	  ,{
        path: "Investor_Risk_Acknowledgment_S",
        element:  <ProtectedRoute>  <Investor_Risk_Acknowledgment_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Data_Room",
        element:  <ProtectedRoute>  <Core_Data_Room />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Data_Room_S",
        element:  <ProtectedRoute>  <Core_Data_Room_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Data_Room_Document",
        element:  <ProtectedRoute>  <Core_Data_Room_Document />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Data_Room_Document_S",
        element:  <ProtectedRoute>  <Core_Data_Room_Document_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Document_Verification",
        element:  <ProtectedRoute>  <Core_Document_Verification />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Document_Verification_S",
        element:  <ProtectedRoute>  <Core_Document_Verification_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Title_Search_Report",
        element:  <ProtectedRoute>  <Core_Title_Search_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Title_Search_Report_S",
        element:  <ProtectedRoute>  <Core_Title_Search_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Appraisal_Report",
        element:  <ProtectedRoute>  <Core_Appraisal_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Appraisal_Report_S",
        element:  <ProtectedRoute>  <Core_Appraisal_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Due_Diligence_Checklist",
        element:  <ProtectedRoute>  <Core_Due_Diligence_Checklist />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Due_Diligence_Checklist_S",
        element:  <ProtectedRoute>  <Core_Due_Diligence_Checklist_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Project_SPV",
        element:  <ProtectedRoute>  <Core_Project_SPV />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Project_SPV_S",
        element:  <ProtectedRoute>  <Core_Project_SPV_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Legal_Opinion",
        element:  <ProtectedRoute>  <Core_Legal_Opinion />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Legal_Opinion_S",
        element:  <ProtectedRoute>  <Core_Legal_Opinion_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Escrow_Account",
        element:  <ProtectedRoute>  <Core_Escrow_Account />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Escrow_Account_S",
        element:  <ProtectedRoute>  <Core_Escrow_Account_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Investor_Protection_Profile",
        element:  <ProtectedRoute>  <Core_Investor_Protection_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Investor_Protection_Profile_S",
        element:  <ProtectedRoute>  <Core_Investor_Protection_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Secondary_Market_Config",
        element:  <ProtectedRoute>  <Core_Secondary_Market_Config />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Secondary_Market_Config_S",
        element:  <ProtectedRoute>  <Core_Secondary_Market_Config_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Governance_Rule_Set",
        element:  <ProtectedRoute>  <Core_Governance_Rule_Set />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Governance_Rule_Set_S",
        element:  <ProtectedRoute>  <Core_Governance_Rule_Set_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Instance",
        element:  <ProtectedRoute>  <Workflow_Instance />  </ProtectedRoute>,
      }
	  ,{
        path: "Workflow_Instance_S",
        element:  <ProtectedRoute>  <Workflow_Instance_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Audit_Log",
        element:  <ProtectedRoute>  <Core_Audit_Log />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Audit_Log_S",
        element:  <ProtectedRoute>  <Core_Audit_Log_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Notification",
        element:  <ProtectedRoute>  <Core_Notification />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Notification_S",
        element:  <ProtectedRoute>  <Core_Notification_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Escrow_Release_Request",
        element:  <ProtectedRoute>  <Core_Escrow_Release_Request />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Escrow_Release_Request_S",
        element:  <ProtectedRoute>  <Core_Escrow_Release_Request_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Tax_Reporting_Package",
        element:  <ProtectedRoute>  <Core_Tax_Reporting_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Tax_Reporting_Package_S",
        element:  <ProtectedRoute>  <Core_Tax_Reporting_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Platform_Dashboard",
        element:  <ProtectedRoute>  <Core_Platform_Dashboard />  </ProtectedRoute>,
      }
	  ,{
        path: "Core_Platform_Dashboard_S",
        element:  <ProtectedRoute>  <Core_Platform_Dashboard_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Asset_Profile",
        element:  <ProtectedRoute>  <RENT_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Asset_Profile_S",
        element:  <ProtectedRoute>  <RENT_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Property_Management_Agreement",
        element:  <ProtectedRoute>  <RENT_Property_Management_Agreement />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Property_Management_Agreement_S",
        element:  <ProtectedRoute>  <RENT_Property_Management_Agreement_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Unit_Profile",
        element:  <ProtectedRoute>  <RENT_Unit_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Unit_Profile_S",
        element:  <ProtectedRoute>  <RENT_Unit_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Offering",
        element:  <ProtectedRoute>  <RENT_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Offering_S",
        element:  <ProtectedRoute>  <RENT_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Class",
        element:  <ProtectedRoute>  <RENT_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Class_S",
        element:  <ProtectedRoute>  <RENT_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Economics",
        element:  <ProtectedRoute>  <RENT_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Economics_S",
        element:  <ProtectedRoute>  <RENT_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <RENT_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <RENT_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Risk_Score",
        element:  <ProtectedRoute>  <RENT_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Risk_Score_S",
        element:  <ProtectedRoute>  <RENT_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Subscription_Order",
        element:  <ProtectedRoute>  <RENT_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Subscription_Order_S",
        element:  <ProtectedRoute>  <RENT_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Ledger",
        element:  <ProtectedRoute>  <RENT_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Token_Ledger_S",
        element:  <ProtectedRoute>  <RENT_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <RENT_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <RENT_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Lease_Record",
        element:  <ProtectedRoute>  <RENT_Lease_Record />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Lease_Record_S",
        element:  <ProtectedRoute>  <RENT_Lease_Record_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Rent_Collection_Record",
        element:  <ProtectedRoute>  <RENT_Rent_Collection_Record />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Rent_Collection_Record_S",
        element:  <ProtectedRoute>  <RENT_Rent_Collection_Record_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Property_Manager_Report",
        element:  <ProtectedRoute>  <RENT_Property_Manager_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Property_Manager_Report_S",
        element:  <ProtectedRoute>  <RENT_Property_Manager_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Tenant_Profile",
        element:  <ProtectedRoute>  <RENT_Tenant_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Tenant_Profile_S",
        element:  <ProtectedRoute>  <RENT_Tenant_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Rent_Roll_Snapshot",
        element:  <ProtectedRoute>  <RENT_Rent_Roll_Snapshot />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Rent_Roll_Snapshot_S",
        element:  <ProtectedRoute>  <RENT_Rent_Roll_Snapshot_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Operating_Expense_Record",
        element:  <ProtectedRoute>  <RENT_Operating_Expense_Record />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Operating_Expense_Record_S",
        element:  <ProtectedRoute>  <RENT_Operating_Expense_Record_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Reserve_Account_Record",
        element:  <ProtectedRoute>  <RENT_Reserve_Account_Record />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Reserve_Account_Record_S",
        element:  <ProtectedRoute>  <RENT_Reserve_Account_Record_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Delinquency_Vacancy_Record",
        element:  <ProtectedRoute>  <RENT_Delinquency_Vacancy_Record />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Delinquency_Vacancy_Record_S",
        element:  <ProtectedRoute>  <RENT_Delinquency_Vacancy_Record_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Escrow_Release_Package",
        element:  <ProtectedRoute>  <RENT_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <RENT_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Investor_Report",
        element:  <ProtectedRoute>  <RENT_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Investor_Report_S",
        element:  <ProtectedRoute>  <RENT_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Distribution_Calculation",
        element:  <ProtectedRoute>  <RENT_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <RENT_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Distribution_Approval",
        element:  <ProtectedRoute>  <RENT_Distribution_Approval />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Distribution_Approval_S",
        element:  <ProtectedRoute>  <RENT_Distribution_Approval_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <RENT_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <RENT_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Exit_Strategy",
        element:  <ProtectedRoute>  <RENT_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "RENT_Exit_Strategy_S",
        element:  <ProtectedRoute>  <RENT_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Asset_Profile",
        element:  <ProtectedRoute>  <REVSHARE_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Asset_Profile_S",
        element:  <ProtectedRoute>  <REVSHARE_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Revenue_Source",
        element:  <ProtectedRoute>  <REVSHARE_Revenue_Source />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Revenue_Source_S",
        element:  <ProtectedRoute>  <REVSHARE_Revenue_Source_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Offering",
        element:  <ProtectedRoute>  <REVSHARE_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Offering_S",
        element:  <ProtectedRoute>  <REVSHARE_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Class",
        element:  <ProtectedRoute>  <REVSHARE_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Class_S",
        element:  <ProtectedRoute>  <REVSHARE_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Economics",
        element:  <ProtectedRoute>  <REVSHARE_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Economics_S",
        element:  <ProtectedRoute>  <REVSHARE_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <REVSHARE_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <REVSHARE_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Risk_Score",
        element:  <ProtectedRoute>  <REVSHARE_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Risk_Score_S",
        element:  <ProtectedRoute>  <REVSHARE_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Subscription_Order",
        element:  <ProtectedRoute>  <REVSHARE_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Subscription_Order_S",
        element:  <ProtectedRoute>  <REVSHARE_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Ledger",
        element:  <ProtectedRoute>  <REVSHARE_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Token_Ledger_S",
        element:  <ProtectedRoute>  <REVSHARE_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <REVSHARE_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <REVSHARE_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Revenue_Verification_Report",
        element:  <ProtectedRoute>  <REVSHARE_Revenue_Verification_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Revenue_Verification_Report_S",
        element:  <ProtectedRoute>  <REVSHARE_Revenue_Verification_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Escrow_Release_Package",
        element:  <ProtectedRoute>  <REVSHARE_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <REVSHARE_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Distribution_Calculation",
        element:  <ProtectedRoute>  <REVSHARE_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <REVSHARE_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Investor_Report",
        element:  <ProtectedRoute>  <REVSHARE_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Investor_Report_S",
        element:  <ProtectedRoute>  <REVSHARE_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <REVSHARE_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <REVSHARE_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Exit_Strategy",
        element:  <ProtectedRoute>  <REVSHARE_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "REVSHARE_Exit_Strategy_S",
        element:  <ProtectedRoute>  <REVSHARE_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Asset_Profile",
        element:  <ProtectedRoute>  <SALEPROFIT_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Asset_Profile_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Exit_Strategy",
        element:  <ProtectedRoute>  <SALEPROFIT_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Exit_Strategy_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Offering",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Offering_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Class",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Class_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Economics",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Economics_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <SALEPROFIT_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Risk_Score",
        element:  <ProtectedRoute>  <SALEPROFIT_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Risk_Score_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <SALEPROFIT_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Subscription_Order",
        element:  <ProtectedRoute>  <SALEPROFIT_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Subscription_Order_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Ledger",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Token_Ledger_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <SALEPROFIT_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Sale_Process",
        element:  <ProtectedRoute>  <SALEPROFIT_Sale_Process />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Sale_Process_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Sale_Process_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Profit_Waterfall",
        element:  <ProtectedRoute>  <SALEPROFIT_Profit_Waterfall />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Profit_Waterfall_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Profit_Waterfall_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Distribution_Calculation",
        element:  <ProtectedRoute>  <SALEPROFIT_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Escrow_Release_Package",
        element:  <ProtectedRoute>  <SALEPROFIT_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Investor_Report",
        element:  <ProtectedRoute>  <SALEPROFIT_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "SALEPROFIT_Investor_Report_S",
        element:  <ProtectedRoute>  <SALEPROFIT_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Asset_Profile",
        element:  <ProtectedRoute>  <EQAPP_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Asset_Profile_S",
        element:  <ProtectedRoute>  <EQAPP_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Offering",
        element:  <ProtectedRoute>  <EQAPP_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Offering_S",
        element:  <ProtectedRoute>  <EQAPP_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Class",
        element:  <ProtectedRoute>  <EQAPP_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Class_S",
        element:  <ProtectedRoute>  <EQAPP_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Economics",
        element:  <ProtectedRoute>  <EQAPP_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Economics_S",
        element:  <ProtectedRoute>  <EQAPP_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <EQAPP_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <EQAPP_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_NAV_Valuation_Report",
        element:  <ProtectedRoute>  <EQAPP_NAV_Valuation_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_NAV_Valuation_Report_S",
        element:  <ProtectedRoute>  <EQAPP_NAV_Valuation_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Appreciation_Calculation",
        element:  <ProtectedRoute>  <EQAPP_Appreciation_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Appreciation_Calculation_S",
        element:  <ProtectedRoute>  <EQAPP_Appreciation_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Risk_Score",
        element:  <ProtectedRoute>  <EQAPP_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Risk_Score_S",
        element:  <ProtectedRoute>  <EQAPP_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <EQAPP_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <EQAPP_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Subscription_Order",
        element:  <ProtectedRoute>  <EQAPP_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Subscription_Order_S",
        element:  <ProtectedRoute>  <EQAPP_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Ledger",
        element:  <ProtectedRoute>  <EQAPP_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Token_Ledger_S",
        element:  <ProtectedRoute>  <EQAPP_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <EQAPP_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <EQAPP_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Distribution_Calculation",
        element:  <ProtectedRoute>  <EQAPP_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <EQAPP_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Escrow_Release_Package",
        element:  <ProtectedRoute>  <EQAPP_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <EQAPP_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Investor_Report",
        element:  <ProtectedRoute>  <EQAPP_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Investor_Report_S",
        element:  <ProtectedRoute>  <EQAPP_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Exit_Strategy",
        element:  <ProtectedRoute>  <EQAPP_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "EQAPP_Exit_Strategy_S",
        element:  <ProtectedRoute>  <EQAPP_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Asset_Profile",
        element:  <ProtectedRoute>  <PREFEQ_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Asset_Profile_S",
        element:  <ProtectedRoute>  <PREFEQ_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Offering",
        element:  <ProtectedRoute>  <PREFEQ_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Offering_S",
        element:  <ProtectedRoute>  <PREFEQ_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Class",
        element:  <ProtectedRoute>  <PREFEQ_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Class_S",
        element:  <ProtectedRoute>  <PREFEQ_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Economics",
        element:  <ProtectedRoute>  <PREFEQ_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Economics_S",
        element:  <ProtectedRoute>  <PREFEQ_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Preferred_Return_Waterfall",
        element:  <ProtectedRoute>  <PREFEQ_Preferred_Return_Waterfall />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Preferred_Return_Waterfall_S",
        element:  <ProtectedRoute>  <PREFEQ_Preferred_Return_Waterfall_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <PREFEQ_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <PREFEQ_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Risk_Score",
        element:  <ProtectedRoute>  <PREFEQ_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Risk_Score_S",
        element:  <ProtectedRoute>  <PREFEQ_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Subscription_Order",
        element:  <ProtectedRoute>  <PREFEQ_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Subscription_Order_S",
        element:  <ProtectedRoute>  <PREFEQ_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Ledger",
        element:  <ProtectedRoute>  <PREFEQ_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Token_Ledger_S",
        element:  <ProtectedRoute>  <PREFEQ_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Capital_Account",
        element:  <ProtectedRoute>  <PREFEQ_Capital_Account />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Capital_Account_S",
        element:  <ProtectedRoute>  <PREFEQ_Capital_Account_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <PREFEQ_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <PREFEQ_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Escrow_Release_Package",
        element:  <ProtectedRoute>  <PREFEQ_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <PREFEQ_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Distribution_Calculation",
        element:  <ProtectedRoute>  <PREFEQ_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <PREFEQ_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Investor_Report",
        element:  <ProtectedRoute>  <PREFEQ_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Investor_Report_S",
        element:  <ProtectedRoute>  <PREFEQ_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <PREFEQ_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <PREFEQ_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Exit_Strategy",
        element:  <ProtectedRoute>  <PREFEQ_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "PREFEQ_Exit_Strategy_S",
        element:  <ProtectedRoute>  <PREFEQ_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Asset_Profile",
        element:  <ProtectedRoute>  <COMEQ_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Asset_Profile_S",
        element:  <ProtectedRoute>  <COMEQ_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Offering",
        element:  <ProtectedRoute>  <COMEQ_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Offering_S",
        element:  <ProtectedRoute>  <COMEQ_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Class",
        element:  <ProtectedRoute>  <COMEQ_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Class_S",
        element:  <ProtectedRoute>  <COMEQ_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Economics",
        element:  <ProtectedRoute>  <COMEQ_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Economics_S",
        element:  <ProtectedRoute>  <COMEQ_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <COMEQ_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <COMEQ_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Risk_Score",
        element:  <ProtectedRoute>  <COMEQ_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Risk_Score_S",
        element:  <ProtectedRoute>  <COMEQ_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Subscription_Order",
        element:  <ProtectedRoute>  <COMEQ_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Subscription_Order_S",
        element:  <ProtectedRoute>  <COMEQ_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Ledger",
        element:  <ProtectedRoute>  <COMEQ_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Token_Ledger_S",
        element:  <ProtectedRoute>  <COMEQ_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Cap_Table",
        element:  <ProtectedRoute>  <COMEQ_Cap_Table />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Cap_Table_S",
        element:  <ProtectedRoute>  <COMEQ_Cap_Table_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <COMEQ_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <COMEQ_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <COMEQ_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <COMEQ_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Equity_Distribution_Waterfall",
        element:  <ProtectedRoute>  <COMEQ_Equity_Distribution_Waterfall />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Equity_Distribution_Waterfall_S",
        element:  <ProtectedRoute>  <COMEQ_Equity_Distribution_Waterfall_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Distribution_Calculation",
        element:  <ProtectedRoute>  <COMEQ_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <COMEQ_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Escrow_Release_Package",
        element:  <ProtectedRoute>  <COMEQ_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <COMEQ_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Investor_Report",
        element:  <ProtectedRoute>  <COMEQ_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Investor_Report_S",
        element:  <ProtectedRoute>  <COMEQ_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Exit_Strategy",
        element:  <ProtectedRoute>  <COMEQ_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "COMEQ_Exit_Strategy_S",
        element:  <ProtectedRoute>  <COMEQ_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Asset_Profile",
        element:  <ProtectedRoute>  <DEBT_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Asset_Profile_S",
        element:  <ProtectedRoute>  <DEBT_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Offering",
        element:  <ProtectedRoute>  <DEBT_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Offering_S",
        element:  <ProtectedRoute>  <DEBT_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Note_Terms",
        element:  <ProtectedRoute>  <DEBT_Note_Terms />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Note_Terms_S",
        element:  <ProtectedRoute>  <DEBT_Note_Terms_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Class",
        element:  <ProtectedRoute>  <DEBT_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Class_S",
        element:  <ProtectedRoute>  <DEBT_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Economics",
        element:  <ProtectedRoute>  <DEBT_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Economics_S",
        element:  <ProtectedRoute>  <DEBT_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Payment_Schedule",
        element:  <ProtectedRoute>  <DEBT_Payment_Schedule />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Payment_Schedule_S",
        element:  <ProtectedRoute>  <DEBT_Payment_Schedule_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <DEBT_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <DEBT_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Risk_Score",
        element:  <ProtectedRoute>  <DEBT_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Risk_Score_S",
        element:  <ProtectedRoute>  <DEBT_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <DEBT_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <DEBT_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Subscription_Order",
        element:  <ProtectedRoute>  <DEBT_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Subscription_Order_S",
        element:  <ProtectedRoute>  <DEBT_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Ledger",
        element:  <ProtectedRoute>  <DEBT_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Token_Ledger_S",
        element:  <ProtectedRoute>  <DEBT_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Interest_Accrual",
        element:  <ProtectedRoute>  <DEBT_Interest_Accrual />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Interest_Accrual_S",
        element:  <ProtectedRoute>  <DEBT_Interest_Accrual_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Distribution_Calculation",
        element:  <ProtectedRoute>  <DEBT_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <DEBT_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Escrow_Release_Package",
        element:  <ProtectedRoute>  <DEBT_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <DEBT_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Investor_Report",
        element:  <ProtectedRoute>  <DEBT_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Investor_Report_S",
        element:  <ProtectedRoute>  <DEBT_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <DEBT_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <DEBT_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Exit_Strategy",
        element:  <ProtectedRoute>  <DEBT_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "DEBT_Exit_Strategy_S",
        element:  <ProtectedRoute>  <DEBT_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Asset_Profile",
        element:  <ProtectedRoute>  <HYBRID_Asset_Profile />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Asset_Profile_S",
        element:  <ProtectedRoute>  <HYBRID_Asset_Profile_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Offering",
        element:  <ProtectedRoute>  <HYBRID_Token_Offering />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Offering_S",
        element:  <ProtectedRoute>  <HYBRID_Token_Offering_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Component_Mix",
        element:  <ProtectedRoute>  <HYBRID_Component_Mix />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Component_Mix_S",
        element:  <ProtectedRoute>  <HYBRID_Component_Mix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Class",
        element:  <ProtectedRoute>  <HYBRID_Token_Class />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Class_S",
        element:  <ProtectedRoute>  <HYBRID_Token_Class_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Economics",
        element:  <ProtectedRoute>  <HYBRID_Token_Economics />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Economics_S",
        element:  <ProtectedRoute>  <HYBRID_Token_Economics_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Legal_Rights_Matrix",
        element:  <ProtectedRoute>  <HYBRID_Legal_Rights_Matrix />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Legal_Rights_Matrix_S",
        element:  <ProtectedRoute>  <HYBRID_Legal_Rights_Matrix_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Risk_Score",
        element:  <ProtectedRoute>  <HYBRID_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Risk_Score_S",
        element:  <ProtectedRoute>  <HYBRID_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Independent_Inspection_Report",
        element:  <ProtectedRoute>  <HYBRID_Independent_Inspection_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Independent_Inspection_Report_S",
        element:  <ProtectedRoute>  <HYBRID_Independent_Inspection_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Subscription_Order",
        element:  <ProtectedRoute>  <HYBRID_Subscription_Order />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Subscription_Order_S",
        element:  <ProtectedRoute>  <HYBRID_Subscription_Order_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Ledger",
        element:  <ProtectedRoute>  <HYBRID_Token_Ledger />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Token_Ledger_S",
        element:  <ProtectedRoute>  <HYBRID_Token_Ledger_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Distribution_Calculation",
        element:  <ProtectedRoute>  <HYBRID_Distribution_Calculation />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Distribution_Calculation_S",
        element:  <ProtectedRoute>  <HYBRID_Distribution_Calculation_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Combined_Distribution_Waterfall",
        element:  <ProtectedRoute>  <HYBRID_Combined_Distribution_Waterfall />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Combined_Distribution_Waterfall_S",
        element:  <ProtectedRoute>  <HYBRID_Combined_Distribution_Waterfall_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Escrow_Release_Package",
        element:  <ProtectedRoute>  <HYBRID_Escrow_Release_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Escrow_Release_Package_S",
        element:  <ProtectedRoute>  <HYBRID_Escrow_Release_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Investor_Report",
        element:  <ProtectedRoute>  <HYBRID_Investor_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Investor_Report_S",
        element:  <ProtectedRoute>  <HYBRID_Investor_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Lifecycle_Milestone",
        element:  <ProtectedRoute>  <HYBRID_Lifecycle_Milestone />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Lifecycle_Milestone_S",
        element:  <ProtectedRoute>  <HYBRID_Lifecycle_Milestone_S />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Exit_Strategy",
        element:  <ProtectedRoute>  <HYBRID_Exit_Strategy />  </ProtectedRoute>,
      }
	  ,{
        path: "HYBRID_Exit_Strategy_S",
        element:  <ProtectedRoute>  <HYBRID_Exit_Strategy_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Opportunity",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Opportunity />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Opportunity_S",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Opportunity_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Source_Verification",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Source_Verification />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Source_Verification_S",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Source_Verification_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pre_Auction_Due_Diligence",
        element:  <ProtectedRoute>  <PREAUCT_Pre_Auction_Due_Diligence />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pre_Auction_Due_Diligence_S",
        element:  <ProtectedRoute>  <PREAUCT_Pre_Auction_Due_Diligence_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Title_Lien_Precheck",
        element:  <ProtectedRoute>  <PREAUCT_Title_Lien_Precheck />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Title_Lien_Precheck_S",
        element:  <ProtectedRoute>  <PREAUCT_Title_Lien_Precheck_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Risk_Assessment",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Risk_Assessment />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Risk_Assessment_S",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Risk_Assessment_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Max_Bid_Analysis",
        element:  <ProtectedRoute>  <PREAUCT_Max_Bid_Analysis />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Max_Bid_Analysis_S",
        element:  <ProtectedRoute>  <PREAUCT_Max_Bid_Analysis_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pre_Auction_Pool",
        element:  <ProtectedRoute>  <PREAUCT_Pre_Auction_Pool />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pre_Auction_Pool_S",
        element:  <ProtectedRoute>  <PREAUCT_Pre_Auction_Pool_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pool_Escrow_Setup",
        element:  <ProtectedRoute>  <PREAUCT_Pool_Escrow_Setup />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Pool_Escrow_Setup_S",
        element:  <ProtectedRoute>  <PREAUCT_Pool_Escrow_Setup_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Compliance_Review",
        element:  <ProtectedRoute>  <PREAUCT_Compliance_Review />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Compliance_Review_S",
        element:  <ProtectedRoute>  <PREAUCT_Compliance_Review_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Pledge",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Pledge />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Pledge_S",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Pledge_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Risk_Acknowledgment",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Risk_Acknowledgment />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Risk_Acknowledgment_S",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Risk_Acknowledgment_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Bid_Authorization",
        element:  <ProtectedRoute>  <PREAUCT_Bid_Authorization />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Bid_Authorization_S",
        element:  <ProtectedRoute>  <PREAUCT_Bid_Authorization_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Bid_Submission",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Bid_Submission />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Bid_Submission_S",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Bid_Submission_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Result",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Result />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Auction_Result_S",
        element:  <ProtectedRoute>  <PREAUCT_Auction_Result_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Refund_Process",
        element:  <ProtectedRoute>  <PREAUCT_Refund_Process />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Refund_Process_S",
        element:  <ProtectedRoute>  <PREAUCT_Refund_Process_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Winning_Bid_Transition",
        element:  <ProtectedRoute>  <PREAUCT_Winning_Bid_Transition />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Winning_Bid_Transition_S",
        element:  <ProtectedRoute>  <PREAUCT_Winning_Bid_Transition_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Update_Report",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Update_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Investor_Update_Report_S",
        element:  <ProtectedRoute>  <PREAUCT_Investor_Update_Report_S />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Final_Pool_Closeout",
        element:  <ProtectedRoute>  <PREAUCT_Final_Pool_Closeout />  </ProtectedRoute>,
      }
	  ,{
        path: "PREAUCT_Final_Pool_Closeout_S",
        element:  <ProtectedRoute>  <PREAUCT_Final_Pool_Closeout_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Auction_Result_Intake",
        element:  <ProtectedRoute>  <POSTAUCT_Auction_Result_Intake />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Auction_Result_Intake_S",
        element:  <ProtectedRoute>  <POSTAUCT_Auction_Result_Intake_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Acquisition_Closing",
        element:  <ProtectedRoute>  <POSTAUCT_Acquisition_Closing />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Acquisition_Closing_S",
        element:  <ProtectedRoute>  <POSTAUCT_Acquisition_Closing_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Title_Cure",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Title_Cure />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Title_Cure_S",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Title_Cure_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Lien_Tax_Clearance",
        element:  <ProtectedRoute>  <POSTAUCT_Lien_Tax_Clearance />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Lien_Tax_Clearance_S",
        element:  <ProtectedRoute>  <POSTAUCT_Lien_Tax_Clearance_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Redemption_Period_Review",
        element:  <ProtectedRoute>  <POSTAUCT_Redemption_Period_Review />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Redemption_Period_Review_S",
        element:  <ProtectedRoute>  <POSTAUCT_Redemption_Period_Review_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Occupancy_Eviction_Status",
        element:  <ProtectedRoute>  <POSTAUCT_Occupancy_Eviction_Status />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Occupancy_Eviction_Status_S",
        element:  <ProtectedRoute>  <POSTAUCT_Occupancy_Eviction_Status_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Property_Condition_Assessment",
        element:  <ProtectedRoute>  <POSTAUCT_Property_Condition_Assessment />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Property_Condition_Assessment_S",
        element:  <ProtectedRoute>  <POSTAUCT_Property_Condition_Assessment_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Rehab_Budget",
        element:  <ProtectedRoute>  <POSTAUCT_Rehab_Budget />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Rehab_Budget_S",
        element:  <ProtectedRoute>  <POSTAUCT_Rehab_Budget_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Appraisal",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Appraisal />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Appraisal_S",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Appraisal_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_SPV_Asset_Transfer",
        element:  <ProtectedRoute>  <POSTAUCT_SPV_Asset_Transfer />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_SPV_Asset_Transfer_S",
        element:  <ProtectedRoute>  <POSTAUCT_SPV_Asset_Transfer_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Tokenization_Readiness_Checklist",
        element:  <ProtectedRoute>  <POSTAUCT_Tokenization_Readiness_Checklist />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Tokenization_Readiness_Checklist_S",
        element:  <ProtectedRoute>  <POSTAUCT_Tokenization_Readiness_Checklist_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Risk_Score",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Risk_Score />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Post_Auction_Risk_Score_S",
        element:  <ProtectedRoute>  <POSTAUCT_Post_Auction_Risk_Score_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Offering_Readiness",
        element:  <ProtectedRoute>  <POSTAUCT_Offering_Readiness />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Offering_Readiness_S",
        element:  <ProtectedRoute>  <POSTAUCT_Offering_Readiness_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Investor_Disclosure_Package",
        element:  <ProtectedRoute>  <POSTAUCT_Investor_Disclosure_Package />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Investor_Disclosure_Package_S",
        element:  <ProtectedRoute>  <POSTAUCT_Investor_Disclosure_Package_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Final_Tokenization_Approval",
        element:  <ProtectedRoute>  <POSTAUCT_Final_Tokenization_Approval />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Final_Tokenization_Approval_S",
        element:  <ProtectedRoute>  <POSTAUCT_Final_Tokenization_Approval_S />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Investor_Update_Report",
        element:  <ProtectedRoute>  <POSTAUCT_Investor_Update_Report />  </ProtectedRoute>,
      }
	  ,{
        path: "POSTAUCT_Investor_Update_Report_S",
        element:  <ProtectedRoute>  <POSTAUCT_Investor_Update_Report_S />  </ProtectedRoute>,
      }

    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
	<AppContext>
		<RouterProvider router={router} />
	</AppContext>
  </React.StrictMode>
);

